import { AdminPanelSettings } from '@mui/icons-material'
import { TeamManagementPanel } from './TeamManagementPanel'
import { useAdventureEditorStore } from '../../../stores/adventureEditorStore'

export function MaintainerPanel() {
  const adventureId = useAdventureEditorStore((state) => state.adventureId)

  return (
    <TeamManagementPanel
      adventureId={adventureId}
      roleType="Maintainer"
      title="Adventure Maintainers"
      description="Maintainers can edit and manage this adventure"
      icon={<AdminPanelSettings />}
    />
  )
}
